import React from 'react';
import { css } from '@emotion/css';
import PropTypes from 'prop-types';
import { min, round, toNumber } from 'lodash';
import { formatPrice } from '../../utils/formatString';

const priceContainerStyle = css`
  display: flex;
  flex-direction: column;
  flex-basis: 15%;
  align-items: end;
  color: #2a2928;
  min-width: 90px;

  @media (max-width: 641px) {
    min-width: initial;
    padding-left: 0.5rem;

    .price-sm {
      font-size: 0.75rem;
      white-space: nowrap;
    }
  }
`;

const priceStyle = css`
  display: flex;
  align-items: center;
  text-align: right;
  white-space: nowrap;
  font-weight: 600;
`;

const discountedPriceStyle = css`
  text-decoration: line-through;
`;

const ItemPrice = (props) => {
  const { quantity, unitPrice, discountPrice } = props;
  const price: number = min([toNumber(unitPrice), toNumber(discountPrice)]) as number;
  const totalPrice = round(price * quantity, 2);
  const regularUnitPrice = toNumber(unitPrice) as number;

  return (
    <div className={priceContainerStyle}>
      <div className={`price-reg ${priceStyle}`} aria-label="total price">
        ${formatPrice(totalPrice)}
      </div>
      {quantity > 1 ? (
        <div className="price-sm" aria-label="unit price">
          ${formatPrice(price)} ea
        </div>
      ) : null}
      {discountPrice < unitPrice ? (
        <div className={`price-sm ${discountedPriceStyle}`} aria-label="regular unit price">
          ${formatPrice(regularUnitPrice)} ea
        </div>
      ) : null}
    </div>
  );
};

ItemPrice.propTypes = {
  quantity: PropTypes.number,
  unitPrice: PropTypes.number,
  discountPrice: PropTypes.number,
};

export default ItemPrice;
